/**
 * @fileoverview パスワード変更成功画面のコンポーネント
 *
 * このファイルでは、パスワード変更が正常に完了した後に表示される
 * 成功メッセージ画面を定義しています。
 */

/**
 * パスワード変更成功画面コンポーネント
 *
 * パスワードの変更が正常に完了したことをユーザーに通知し、
 * 次のアクション（ホームに戻る、ユーザー設定に移動するなど）への
 * ナビゲーションを提供します。
 *
 * @returns {JSX.Element} パスワード変更成功メッセージ画面
 */
import { Stack, Text } from "@mantine/core";

import { useNavigate } from "@/router";
import { Card } from "@/components/card";
import { Button } from "@/components/button";

export default function ChagnePasswordPage() {
  const navigate = useNavigate();

  return (
    <Card title="パスワード変更">
      <Stack className="gap-10">
        <Text>パスワードを変更しました。</Text>
        <div className="flex justify-end">
          <Button text="マイページへ戻る" onClick={() => navigate("/user")} />
        </div>
      </Stack>
    </Card>
  );
}
